<template>
	<div>
		<!-- 卡片试图区域 -->
		<el-card>
			<!-- 添加角色按钮区域 -->
			<el-row>
				<el-col>
					<el-button type="primary" @click="addRoleDialogVisible=true">添加角色</el-button>
					</el-col>
				</el-row>
				<!-- 角色列表区域 -->
				<el-table
				:data="rolelist"
				border
				stripe
				row-key="rid"
				>
				<!-- 索引列 -->
					<el-table-column
					  type="index"
					 >
					</el-table-column>
					<el-table-column
					  prop="rolename"
					  label="角色名称">
					</el-table-column>
					<el-table-column
					  prop="roleDesc"
					  label="角色描述">
					</el-table-column>
					<el-table-column
					  label="操作">
						<template slot-scope="scope">
				<el-button type="primary" size="mini" icon="el-icon-edit" @click="showRoleEditDialog(scope.row.rid)">编辑</el-button>
				<el-button type="danger"  size="mini"  icon="el-icon-delete" @click="removeRoleById(scope.row.rid)">删除</el-button>

          <el-button type="warning" size="mini"  icon="el-icon-setting" @click="showSetRightDialog(scope.row)">分配权限</el-button>
						</template>
					</el-table-column>
					</el-table>
			</el-card>
			<!-- 添加角色的对话框 -->
			<el-dialog
			  title="添加角色"
			  :visible.sync="addRoleDialogVisible"
			  width="50%"
			  @close="addRoleDialogClosed"
			>
			  <!-- 内容主体区域 -->
			 <el-form
			 :rules="addRoleFormRules"
			 ref="addRoleFormRef"
			 :model="addRoleForm"
			 label-width="100px">
			   <el-form-item label="角色名称" prop="rolename">
			     <el-input v-model="addRoleForm.rolename"></el-input>
			   </el-form-item>
			   <el-form-item label="角色描述" prop="roleDesc">
			     <el-input v-model="addRoleForm.roleDesc"></el-input>
			   </el-form-item>
			   </el-form>
			  <!-- 底部区域 -->
			  <span slot="footer" class="dialog-footer">
			    <el-button @click="addRoleDialogVisible = false">取 消</el-button>
			    <el-button type="primary" @click="addRole">确 定</el-button>
			  </span>
			</el-dialog>
			<!-- 编辑角色的对话框 -->
			<el-dialog
			  title="编辑角色"
			  :visible.sync="editRoleDialogVisible"
			  width="50%"
			  @close="editRoleDialogClosed"
			>
			  <!-- 内容主体区域 -->
			 <el-form
			 :rules="editRoleFormRules"
			 ref="editRoleFormRef"
			 :model="editRoleForm"
			 label-width="100px">
			   <el-form-item label="角色名称" prop="rolename">
			     <el-input v-model="editRoleForm.rolename"></el-input>
			   </el-form-item>
			   <el-form-item label="角色描述" prop="roleDesc">
			     <el-input v-model="editRoleForm.roleDesc"></el-input>
			   </el-form-item>
			   </el-form>
			  <!-- 底部区域 -->
			  <span slot="footer" class="dialog-footer">
			    <el-button @click="editRoleDialogVisible = false">取 消</el-button>
			    <el-button type="primary" @click="editRole">确 定</el-button>
			  </span>
			</el-dialog>
			<!-- 分配权限的对话框 -->
			<el-dialog
			  title="分配权限"
			  :visible.sync="setRightDialogVisible"
			  width="50%"
			  @close="setRightDialogClosed"
			  >
			  <!--  check-strictly这个属性父节点与子节点互不关联！！！！！！！！！！！！！！！！！-->
			  <el-tree
			  :data="rightslist"
			  :props="treeProps"
			  show-checkbox
			  node-key="pid"
			  default-expand-all
			  :default-checked-keys="defKeys"
			  ref="treeRef"
			  check-strictly
			  >
			  </el-tree>
			  <span slot="footer" class="dialog-footer">
			    <el-button @click="setRightDialogVisible = false">取 消</el-button>
			    <el-button type="primary" @click="allRights">确 定</el-button>
			  </span>
			</el-dialog>
		</div>
</template>

<script>
	export default{
		data(){
			return{
				//所有角色列表数据
				rolelist:[],
				//控制分配权限对话框的显示与隐藏
				setRightDialogVisible:false,
				//所有权限的数据
				rightslist:[],
				// //树形控件的属性绑定对象
				treeProps:{
					label:'label',
					children:'children'
				},
				// //默认选中的节点Id值
				 defKeys:[],
				// //当前即将分配权限的角色id
				 roleId:'',
				 //菜单权限的信息
				 rightId:'',
				//控制添加角色对话框的显示与隐藏
				addRoleDialogVisible:false,
				//添加角色的表单数据
				addRoleForm:{
					rolename:'',
					roleDesc:'',

				},
				//添加角色的表单验证
				addRoleFormRules:{
					rolename:[
						{required:true,message:'请输入角色名称',trigger:'blur'},
						{min:2,max:10,message:'角色名称的长度在2~10字符之间',trigger:'blur'}
					],
				},
				//控制编辑角色对话框的显示与隐藏
				editRoleDialogVisible:false,
				//编辑角色的表单数据
				editRoleForm:{},
				//编辑角色的表单验证
				editRoleFormRules:{
					rolename:[
						{required:true,message:'请输入角色名称',trigger:'blur'},
						{min:2,max:10,message:'角色名称的长度在2~10字符之间',trigger:'blur'}
					],
				}
			}
		},
		created(){
			this.getRolesList()
		},
		methods:{
			//获取所有角色的列表
			async getRolesList(){
				const {data:res} = await this.$http.getrolesList()
				if (res.status !==0){
					return this.$message.error('获取角色列表失败!')
				}
				this.rolelist = res.data
			},
		 addRole(){
				this.$refs.addRoleFormRef.validate(async valid =>{
					if (!valid) return
					const {data:res} = await this.$http.addroles(this.addRoleForm)
					if (res.status !==0){
						return this.$message.error('添加角色失败!')
					}
					this.$message.success('添加角色成功!')
					//隐藏添加角色的对话框
					this.addRoleDialogVisible = false
					//重新获取角色列表数据
					this.getRolesList()
					})
			},
			//监听添加角色对话框的关闭
			addRoleDialogClosed(){
				this.$refs.addRoleFormRef.resetFields()
			},
			//展示编辑角色的对话框
				async showRoleEditDialog(id){
					const {data:res} = await this.$http.byIdroles(id)
					if (res.status !==0){
						return this.$message.error('查询角色信息失败!')
					}
					this.editRoleForm = res.data
					console.log(this.editRoleForm)
					this.editRoleDialogVisible = true
				},
			//修改角色信息并提交
			editRole(){
				this.$refs.editRoleFormRef.validate(async valid =>{
					if (!valid) return
				const {data:res} = await this.$http.editRoles(this.editRoleForm)
				if (res.status !==0){
					return this.$message.error('修改角色失败!')
				}
				this.$message.success('修改角色成功!')
				//隐藏修改角色的对话框
				this.editRoleDialogVisible = false
				//重新获取角色列表数据
				this.getRolesList()

				})
			},
			//监听修改角色对话框的关闭
			editRoleDialogClosed(){
				this.$refs.editRoleFormRef.resetFields()
			},

			//根据Id删除对应的角色信息
			async removeRoleById(id){
				//弹框询问角色是否删除数据
				        const confirmResult = await this.$confirm('此操作将永久删除该角色, 是否继续?', '提示', {
				          confirmButtonText: '确定',
				          cancelButtonText: '取消',
				          type: 'warning'
				        }).catch(err => err)
						if (confirmResult !== 'confirm'){
							return this.$message.info('已取消删除')
						}
						const {data:res} = await this.$http.delRoles(id)
						if (res.status !==0){
							return this.$message.error('删除角色失败!')
						}
						this.$message.success('删除角色成功!')
						this.getRolesList()
			},
			// //展示分配权限的对话框
			async showSetRightDialog(role){
				this.rightId = role.pid
				this.roleId = role.rid
				const { data: res } = await this.$http.getAllMenu()
				this.rightslist = res.data
				//三目运算符做判断条件，如果新建的角色，pid为空null则给空数组，否则报错的
			    this.defKeys=this.rightId == null? []:this.rightId.split(",")
				console.log(this.defKeys)
				this.setRightDialogVisible = true
			},
			// //监听分配权限对话框的关闭事件
			setRightDialogClosed(){
				this.defKeys = []
			},
			// //点击为角色分配权限
			async allRights(){
				let keys = [
					...this.$refs.treeRef.getCheckedKeys(),
					...this.$refs.treeRef.getHalfCheckedKeys()
				]
				let idStr = keys.join(",")
				this.rightId = idStr
		        console.log(this.rightId)
				const {data:res} = await this.$http.savePowerRoles(
				{data:{
					rid:this.roleId,
					pid:this.rightId
				}}
				)
				if (res.status !==0){
				 return this.$message.error('更新权限失败!')
				}
				this.$message.success('更新权限成功!')
				this.setRightDialogVisible = false
				this.getRolesList()
        //this.$store.dispatch('getMenus')

			}
		}
	}
</script>

<style lang="less" scoped>
	.el-tag{
		margin: 7px;
	}
	.bdtop{
		border-top: 1px solid #eee;
	}
	.bdbottom{
		border-bottom: 1px solid #eee;
	}
	.vcenter{
		display: flex;
		align-items: center;
	}
</style>
